function injectStyle (ssrContext) {
  require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-0072a12a\",\"scoped\":true,\"hasInlineConfig\":false}!stylus-loader?sourceMap!./clientAddressPopup.styl")
}
var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./clientAddressPopup.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0072a12a\",\"hasScoped\":true}!./clientAddressPopup.html"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0072a12a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/clientAddressPopup/clientAddressPopup.vue
// module id = 2689
// module chunks = 1